import React, { useState, useEffect } from 'react';
import Button from '../../components/ui/Button';
import api from '../../api/api';

const PurchaseOrderHeader = ({
  orderDetails,
  user,
  setSuccess,
  setError,
  setOrderDetails,
}) => {
  const [editableAddress, setEditableAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [amountPaid, setAmountPaid] = useState(0);
  const [payMode, setPayMode] = useState('');
  const [refNo, setRefNo] = useState('');
  const [paymentModes, setPaymentModes] = useState([]);
  const [orderDate, setOrderDate] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  useEffect(() => {
    if (orderDetails) {
      setEditableAddress(orderDetails.Address || '');
      setAmountPaid(orderDetails.amountPaid ?? 0);
      setRefNo(orderDetails.Refno ?? '');
      setPayMode(orderDetails.Paymode ?? '');
      setPaymentModes(orderDetails.Table2 || []);
      setOrderDate(formatDate(orderDetails.Podate));
    }
  }, [orderDetails]);

  const handleUpdateOrder = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await api.updatePurchaseOrderDetails({
        Poid: orderDetails.Poid,
        Address: editableAddress,
        MobileNo: orderDetails.MobileNo,
        Podate: orderDate,
        Deliverydate: new Date(orderDetails.DeliveryDate)
          .toISOString()
          .split('T')[0],
        User: user.UsrName,
        amountPaid,
        Paymode: payMode,
        Refno: refNo,
      });

      if (setOrderDetails) {
        setOrderDetails((prev) => ({
          ...prev,
          Address: editableAddress,
          amountPaid,
          Paymode: payMode,
          Refno: refNo,
          Podate: orderDate,
        }));
      }

      setSuccess('Order details updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error(err);
      setError('Failed to update order.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto overflow-hidden bg-white shadow-lg rounded-xl">
      {/* Section Title */}
      <h2 className="mb-4 text-lg font-bold text-center sm:text-xl">
        Suppiler & Purchase Order Info
      </h2>

      {/* Responsive Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {/* Left Column */}
        <div className="space-y-4">
          {/* Customer Name */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Supplier Name
            </label>
            <input
              type="text"
              value={orderDetails?.Vname || ''}
              readOnly
              className="w-full p-2 text-gray-700 bg-gray-100 border rounded-lg"
            />
          </div>

          {/* Address */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Address*
            </label>
            <textarea
              value={editableAddress}
              onChange={(e) => setEditableAddress(e.target.value)}
              rows="3"
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Amount Paid */}
          {/* <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Amount Paid
            </label>
            <input
              type="number"
              value={amountPaid}
              onChange={(e) => setAmountPaid(Number(e.target.value))}
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div> */}

          {/* Reference No */}
          {/* <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Reference No
            </label>
            <input
              type="text"
              value={refNo}
              onChange={(e) => setRefNo(e.target.value)}
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div> */}
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          {/* Mobile */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Mobile
            </label>
            <input
              type="text"
              value={orderDetails?.MobileNo || ''}
              readOnly
              className="w-full p-2 text-gray-700 bg-gray-100 border rounded-lg"
            />
          </div>

          {/* Balance */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Balance
            </label>
            <input
              type="text"
              value={(orderDetails?.Balance || 0).toLocaleString('en-IN', {
                style: 'currency',
                currency: 'INR',
              })}
              readOnly
              className="w-full p-2 text-gray-700 bg-gray-100 border rounded-lg"
            />
          </div>

          {/* Order Date */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Delivery Date
            </label>
            <input
              type="date"
              value={orderDate}
              onChange={(e) => setOrderDate(e.target.value)}
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Pay Mode */}
          {/* <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Pay Mode
            </label>
            <select
              value={payMode}
              onChange={(e) => setPayMode(e.target.value)}
              disabled={!!orderDetails?.Paymode}
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select</option>
              {paymentModes.map((mode, index) => (
                <option key={index} value={mode.Mode}>
                  {mode.Mode}
                </option>
              ))}
            </select>
          </div> */}
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-3 mt-6">
        <Button
          type="button"
          onClick={handleUpdateOrder}
          disabled={loading}
          className="px-4 py-2"
        >
          {loading ? 'Updating...' : 'Update Purchase Order Details'}
        </Button>
      </div>
    </div>
  );
};

export default PurchaseOrderHeader;

